import ReminderTabContent from "../../../reminders/external-components/ReminderTabContent/ReminderTabContent";
import useGetTopicReminders from "../../api/useGetTopicReminders";

type Props = {
  topicId: string;
}

export default function ReminderTabContentWrapper(props: Props) {
  const { data: currentReminders, isLoading: currentLoading } = useGetTopicReminders(props.topicId, false);
  const { data: pastReminders, isLoading: pastLoading } = useGetTopicReminders(props.topicId, true);

  return (
    <ReminderTabContent
      currentReminders={currentReminders ?? []}
      currentLoading={currentLoading}
      pastReminders={pastReminders ?? []}
      pastLoading={pastLoading}
      displayProvider
      displaySubject={false}
    />
  )
}
